import {Action} from '@ngrx/store';
import {InsertProgram} from 'src/app/utility/interfaces/insert-program.interface';

export const INSERT_PROGRAM = '[Program] insert';
export const INSERT_EPG_ID = '[Program] epgProgramId';
export const REMOVE_PROGRAM = '[Program] removeInsertProgram';

export class InsertEpgProgram implements Action {
  readonly type = INSERT_PROGRAM;
  constructor(public payload: InsertProgram) {}
}

export class EpgProgramId implements Action {
  readonly type = INSERT_EPG_ID;
  constructor(public payload: string) {}
}

export class RemoveInsertedProgram implements Action {
  readonly type = REMOVE_PROGRAM;
  constructor(public payload: number) {}
}

export type Actions = InsertEpgProgram | EpgProgramId | RemoveInsertedProgram;
